import { useState } from 'react';

// Drop-in replacement for a bare <img> wherever it's a small avatar/logo that people
// actually need to see clearly (a profile photo, a company logo) -- click opens a
// full-size lightbox. Self-contained (each instance owns its own zoom state), and
// stops propagation so it composes safely inside a clickable row/card without also
// triggering that row's own onClick.
export default function ZoomableImg({ src, alt = '', style, imgProps }) {
  const [zoomed, setZoomed] = useState(false);
  if (!src) return null;
  return (
    <>
      <img
        src={src}
        alt={alt}
        onClick={e => { e.stopPropagation(); setZoomed(true); }}
        style={{ ...style, cursor: 'zoom-in' }}
        {...imgProps}
      />
      {zoomed && (
        <div
          onClick={e => { e.stopPropagation(); setZoomed(false); }}
          style={{
            position: 'fixed', inset: 0, zIndex: 4000,
            backgroundColor: 'rgba(0,0,0,0.85)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: '24px', cursor: 'zoom-out',
          }}
        >
          <img
            src={src}
            alt={alt}
            style={{ maxWidth: '90vw', maxHeight: '90vh', objectFit: 'contain', borderRadius: '10px', boxShadow: '0 12px 48px rgba(0,0,0,0.5)' }}
          />
          <button
            onClick={e => { e.stopPropagation(); setZoomed(false); }}
            aria-label="Close"
            style={{
              position: 'absolute', top: '16px', right: '16px',
              width: '36px', height: '36px', borderRadius: '50%',
              background: 'rgba(255,255,255,0.12)', border: 'none', color: '#fff',
              fontSize: '20px', lineHeight: 1, cursor: 'pointer',
            }}
          >×</button>
        </div>
      )}
    </>
  );
}
